import { ApplicationConfig, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './helper/global-error-handler';
import { provideRouter } from '@angular/router';
import { routerConfig } from './app.routes';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { performanceInterceptor } from './helper/performance.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([performanceInterceptor])
    ),
    routerConfig,
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};